import React from 'react';

export default (
        <svg viewBox="0 0 27 38" fill="none" ><rect x="0.7" y="0.7" width="25.6" height="36.6" rx="10.2" stroke="#3E454C" strokeWidth="0.6"></rect><path d="M13.9465 12.6992V25.2992" stroke="#3E454C" strokeWidth="0.6" strokeLinecap="round" strokeLinejoin="round"></path><path d="M17.6879 21.6992L13.9465 25.2992L10.205 21.6992" stroke="#3E454C" strokeWidth="0.6" strokeLinecap="round" strokeLinejoin="round"></path></svg>
);
